import React from 'react';
import { SEO } from '../components/SEO';

export const Legal = () => {
  return (
    <>
      <SEO title="Mentions Légales et CGU" />
      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* CGU Section */}
          <section className="bg-white rounded-lg shadow-lg p-8 mb-8">
            <h1 className="text-3xl font-bold mb-6">CONDITIONS GÉNÉRALES D'UTILISATION (CGU)</h1>
            <p className="text-sm text-gray-600 mb-6">Dernière mise à jour : 29 Novembre 2024</p>
            
            <div className="prose prose-blue max-w-none">
              <p className="mb-6">
                Bienvenue sur le site internet du Cercle Poincaré (ci-après désigné le "Site"). 
                En accédant à ce Site, vous acceptez les présentes Conditions Générales d'Utilisation (CGU). 
                Si vous n'acceptez pas ces conditions, veuillez cesser d'utiliser le Site.
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4">1. Objet</h2>
              <p>Les présentes CGU définissent les règles d'utilisation du Site ainsi que les droits et obligations des utilisateurs.</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">2. Accès au Site</h2>
              <p>L'accès au Site est ouvert à toute personne disposant d'un accès Internet. Le Cercle Poincaré se réserve le droit de suspendre, modifier ou interrompre le Site à tout moment, notamment pour des raisons techniques ou de maintenance.</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">3. Propriété intellectuelle</h2>
              <p>Tous les contenus présents sur le Site (textes, images, vidéos, logos, etc.) sont protégés par les lois en vigueur sur la propriété intellectuelle. Toute reproduction, représentation ou diffusion, même partielle, est strictement interdite sans autorisation écrite préalable.</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">4. Responsabilité</h2>
              <p>Le Cercle Poincaré ne saurait être tenu responsable des dommages directs ou indirects liés à l'utilisation du Site. L'utilisateur s'engage à ne pas utiliser le Site de manière frauduleuse ou illicite.</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">5. Données personnelles</h2>
              <p>L'utilisation du Site peut entraîner la collecte de données personnelles. Ces données sont traitées conformément à notre Politique de confidentialité.</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">6. Liens hypertextes</h2>
              <p>Le Site peut contenir des liens vers des sites tiers. Le Cercle Poincaré décline toute responsabilité quant au contenu de ces sites externes.</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">7. Modification des CGU</h2>
              <p>Le Cercle Poincaré se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs sont invités à consulter cette page régulièrement.</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">8. Loi applicable</h2>
              <p>Les présentes CGU sont soumises au droit français. Tout litige sera soumis aux juridictions compétentes.</p>
            </div>
          </section>

          {/* Mentions Légales Section */}
          <section className="bg-white rounded-lg shadow-lg p-8">
            <h1 className="text-3xl font-bold mb-6">MENTIONS LÉGALES</h1>
            <div className="prose prose-blue max-w-none">
              <p className="mb-6">
                Conformément aux articles 6-III et 19 de la loi n° 2004-575 du 21 juin 2004 pour la 
                Confiance dans l'Économie Numérique (LCEN), voici les mentions légales du Site :
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4">1. Éditeur du Site</h2>
              <ul className="list-none pl-0">
                <li>Nom : Cercle Poincaré</li>
                <li>Adresse : 2 rue des 4 Églises, 54000 Nancy, France</li>
                <li>Email : cerclepoincare.001@gmail.com</li>
                <li>Téléphone : 06 14 15 45 90</li>
                <li>Numéro SIRET : W543010555</li>
              </ul>

              <h2 className="text-xl font-semibold mt-8 mb-4">2. Hébergeur</h2>
              <ul className="list-none pl-0">
                <li>Nom : Netlify</li>
                <li>Adresse : 2325 3rd Street, Suite 215, San Francisco, CA 94107, États-Unis</li>
                <li>Email : privacy@netlify.com</li>
                <li>Site web : https://www.netlify.com</li>
              </ul>

              <h2 className="text-xl font-semibold mt-8 mb-4">3. Directeur de la publication</h2>
              <ul className="list-none pl-0">
                <li>Nom : Malika DATI</li>
                <li>Fonction : Secrétaire générale</li>
                <li>Contact : malika.dati@icloud.com</li>
              </ul>

              <h2 className="text-xl font-semibold mt-8 mb-4">4. Collecte de données</h2>
              <p>Le Site respecte la législation en vigueur en matière de protection des données personnelles (RGPD).</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">5. Propriété intellectuelle</h2>
              <p>Tout le contenu du Site (textes, images, graphismes, logos, vidéos, etc.) est protégé par le Code de la propriété intellectuelle. Toute utilisation non autorisée peut entraîner des poursuites judiciaires.</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">6. Cookies</h2>
              <p>Le Site utilise des cookies pour améliorer l'expérience utilisateur. Vous pouvez gérer vos préférences en matière de cookies à tout moment via les paramètres de votre navigateur.</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">7. Conditions d'utilisation</h2>
              <p>Pour toute question relative aux conditions d'utilisation, veuillez nous contacter à cerclepoincare.001@gmail.com.</p>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};